import Api from "../../api/index";
import idb from "../../idb/solutions";
import { networkInterfaces } from "os";

const Solution = {
  namespaced: true,
  state: {
    allSolutions: null,
    oneSolution: null,
    solutionID: null,

    loading_solutions: false,

    createSolutionWasGood: null,
    createSolutionMessage: null,

    updateSolutionWasGood: null,
    updateSolutionMessage: null,
  },

  mutations: {
    setLoadingSolution(state, val){
      // console.log('setando loading solutions: ', val);
      state.loading_solutions = val
    },
    resetAllSolutions(state) {
      state.allSolutions = null;
    },
    setAllSolutions(state, { all, filter }) {
      state.allSolutions = all.data.map((obj) => obj.attributes);
      // if se ele realmente buscou uma solution do network !! pra nao ficar apagando e nao ter o q buscar do idb
      // if (!filter) {
      //   idb.store_solutions(all.data.map((obj) => obj.attributes)).then(r=>{

      //     console.log('chamar o outro method aki');
      //   })
      // }
    },
    setOfflineSolutions(state) {
      if (state.allSolutions == null) {
        idb.get_solutions().then((solutions) => {
          // console.log("HEY SOLUTION: ", {solutions})
          state.allSolutions = solutions;
        });
      }
    },

    createResponse(state, { was_good, msg }) {
      state.createSolutionWasGood = was_good;
      state.createSolutionMessage = msg;
      setTimeout(() => {
        state.createSolutionWasGood = null;
      }, 100);
    },
    updateResponse(state, { was_good, msg }) {
      state.updateSolutionWasGood = was_good;
      state.updateSolutionMessage = msg;
      setTimeout(() => {
        state.updateSolutionWasGood = null;
      }, 100);
    },

    setOneSolution(state, oneSolution) {
      state.oneSolution = oneSolution;
      localStorage.setItem("solution_id", oneSolution.data.attributes.id);
      localStorage.setItem("solution_name", oneSolution.data.attributes.name);
    },
    writeSolutionID(state, { id, start, id_opts }) {
      console.log(localStorage.getItem("solution_id"), {start, id_opts});
      if (start){
        if (id_opts){
          state.solutionID = id_opts.includes(localStorage.getItem("solution_id"))? localStorage.getItem("solution_id") : id
        }else {
          state.solutionID = localStorage.getItem("solution_id") || id;
        }
      } else {
        state.solutionID = id
      }
      // state.solutionID = start? localStorage.getItem("solution_id")? localStorage.getItem("solution_id") : id : id;
      localStorage.setItem("solution_id", state.solutionID);
    },

    removeDeletedForm(state, {id, solution_id}){
      console.log({id, solution_id});
      let sol = state.allSolutions.find(as=> Number(as.id) == Number(solution_id))
      if (sol.forms.data.find(fd => Number(fd.id) == Number(id))){
        let f_idx = sol.forms.data.findIndex(fd => Number(fd.id) == Number(id))
        state.allSolutions.find(as=> Number(as.id) == Number(solution_id)).forms.data.splice(f_idx, 1)
      }
    },
  },
  actions: {
    index(context, filter) {
      // context.commit("setOfflineSolutions");
      // return true
      context.commit("setLoadingSolution", true);
      if (!filter) {
        context.commit("resetAllSolutions");
      }
      // setTimeout(() => {
      // Api.Solution.index(filter).then((response) => response.data).then((allSolutions) => {
      Api.Solution.indexLean(filter).then((response) => response.data).then((allSolutions) => {
        context.commit("setAllSolutions", { all: allSolutions, filter: filter, });
        if (!filter) {
          // console.log('chama o idb');
          idb.store_solutions(allSolutions.data.map((obj) => obj.attributes)).then(r=>{
            // console.log('chamar o outro method aki');
            // context.dispatch('CustomField/index', null, {root: true})
            context.dispatch('CustomField/indexV2', null, {root: true})
            context.dispatch('User/preloadUsersToIdb', null, {root: true})
          })
        }
      })
      .catch(function(error) {
        // auto-comment// console.log(error);
        context.commit("setOfflineSolutions");
      }).finally(()=>{
        context.commit("setLoadingSolution", false);
      })
      // }, 5000);
    },
    show(context, id) {
      Api.Solution.show(id)
        .then((response) => response.data)
        .then((oneSolution) => {
          context.commit("setOneSolution", oneSolution);
        })
        .catch(function(error) {
          // auto-comment// console.log(error)
        });
    },

    create(context, new_solution) {
      Api.Solution.create(new_solution)
        .then((r) => r.data)
        .then((solution) => {
          context.commit("createResponse", { msg: "", was_good: true });
          // this.allSolutions = solutions.data.map(o=>o.attributes)
        })
        .catch((err) => {
          // auto-comment// console.log({err});
          context.commit("createResponse", { msg: "", was_good: false });
        });
    },
    update(context, new_solution) {
      Api.Solution.update(new_solution)
        .then((r) => r.data)
        .then((solution) => {
          context.commit("updateResponse", { msg: "", was_good: true });
          // this.allSolutions = solutions.data.map(o=>o.attributes)
        })
        .catch((err) => {
          // auto-comment// console.log({err});
          context.commit("updateResponse", { msg: "", was_good: false });
        });
    },

    writeSolutionID(context, { id, start, id_opts }) {
      context.commit("writeSolutionID", { id: id, start: start, id_opts });
    },


    removeDeletedForm(context, deleted_form){
      context.commit("removeDeletedForm", { id: deleted_form.id, solution_id: deleted_form.solution_id });
    }
  },
};

export default Solution;
